import sliceCreator from '../../index.jsx';
import {GET_SEASONS} from '../../../constants/index.jsx';
const _getAllSeasonsAction = sliceCreator('GET_SEASONS', GET_SEASONS, 'get');

const { asyncAction: getAllSeasonsAction, reducer, clearData: clearGetAllSeasonsAction } = _getAllSeasonsAction;

export default reducer;

export {
    getAllSeasonsAction,
    clearGetAllSeasonsAction
}